import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";

interface TokenCostsTableProps {
  tokenCosts: any[];
  onEdit: (cost: any) => void;
}

export const TokenCostsTable = ({ tokenCosts, onEdit }: TokenCostsTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Model Name</TableHead>
          <TableHead>Token Cost</TableHead>
          <TableHead>Created At</TableHead>
          <TableHead>Updated At</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {tokenCosts.map((cost) => (
          <TableRow key={cost.id}>
            <TableCell>{cost.model_name}</TableCell>
            <TableCell>{cost.token_cost}</TableCell>
            <TableCell>{new Date(cost.created_at).toLocaleDateString()}</TableCell>
            <TableCell>{new Date(cost.updated_at).toLocaleDateString()}</TableCell>
            <TableCell>
              <Button variant="ghost" size="sm" onClick={() => onEdit(cost)}>
                <Pencil className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};